<template>
  <div class="parent-list-page app-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.parent.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>
    
    <!-- Create -->
    <div class="app-content-create">
      <!-- Filter button -->
      <app-filter-button 
        :active.sync="activeFilter"
      />
    </div>

    <!-- Filter form -->
    <app-parent-list-filter 
      :style="{ display: activeFilter ? 'initial' : 'none' }" 
      :subpropertyId="subpropertyId"
    />

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.parent.list.title"></app-i18n>
      </h1>

      <app-parent-list-toolbar :subpropertyId="subpropertyId"></app-parent-list-toolbar>
      <app-parent-list-table  :subpropertyId="subpropertyId"></app-parent-list-table>
    </div>
  </div>
</template>

<script>
import ParentListFilter from '@modules/parent/components/parent-list-filter.vue';
import ParentListTable from '@modules/parent/components/parent-list-table.vue';
import ParentListToolbar  from '@modules/parent/components/parent-list-toolbar.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'app-parent-list-page',
  props: {
    subpropertyId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      rows: 'parent/list/rows',
    }),
  },

  data() {
    return {
      activeFilter: false,
    }
  },

  components: {
    [ParentListFilter.name]: ParentListFilter,
    [ParentListTable.name]: ParentListTable,
    [ParentListToolbar.name]: ParentListToolbar,
  },
};
</script>

<style>
</style>
